var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassEmptyState",
    {
      attrs: {
        illustrationPath:
          "/ressources/logged/img/illustrations/empty-report-favorites.svg",
        title: _vm.translations.title,
        caption: _vm.translations.caption
      }
    },
    [
      _c("CompassButton", {
        attrs: { label: _vm.translations.actions.redirect_to_all_reports },
        on: {
          click: function($event) {
            return _vm.$emit("redirectToAllReports")
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }